module.exports = __webpack_public_path__ + "img/bottom.5904e232.png";